import { ChakraBox, ChakraFlex, Tab } from '@equip.health/ui';

import { CarePlanEvents } from '~/analytics/carePlanEvents';
import { DischargePlanEvents } from '~/analytics/dischargePlanEvents';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

const TOP_LEVEL_ID = 'care-planning-header';

export const CarePlanningTab = {
  CARE_PLAN: 'care-plan',
  DISCHARGE_PLAN: 'discharge-plan',
} as const;

export type CarePlanningTabValue =
  (typeof CarePlanningTab)[keyof typeof CarePlanningTab];

const tabEventMap: Record<
  CarePlanningTabValue,
  CarePlanEvents | DischargePlanEvents
> = {
  [CarePlanningTab.CARE_PLAN]: CarePlanEvents.carePlanSubTabButtonClicked,
  [CarePlanningTab.DISCHARGE_PLAN]:
    DischargePlanEvents.dischargePlanSubTabButtonClicked,
};

export type CarePlanningSubTabHeaderProps = {
  onTabChange: (tab: CarePlanningTabValue) => void;
  tabs: CarePlanningSubTabProps[];
  selectedTab: CarePlanningTabValue;
};

export type CarePlanningSubTabProps = {
  title: string;
  value: CarePlanningTabValue;
};

const CarePlanningSubTabHeader = ({
  onTabChange,
  tabs,
  selectedTab,
}: CarePlanningSubTabHeaderProps) => {
  const { trackEvent } = useAnalytics();

  const handleTabClick = (tab: CarePlanningSubTabProps) => {
    onTabChange(tab.value);
    trackEvent(tabEventMap[tab.value]);
  };

  return (
    <ChakraBox margin="18px 0 0 0">
      <ChakraFlex
        align="center"
        backgroundColor="neutral.background.primary"
        gap="12px"
        id={TOP_LEVEL_ID}
        justify="space-between"
        position="relative"
      >
        <ChakraFlex align="center" gap="8px">
          {tabs.map((tab) => (
            <Tab
              id={`${TOP_LEVEL_ID}__tab-${tab.value}`}
              isActive={selectedTab === tab.value}
              key={tab.value}
              onClick={() => handleTabClick(tab)}
              title={tab.title}
              variant="bubble"
            />
          ))}
        </ChakraFlex>
      </ChakraFlex>
    </ChakraBox>
  );
};

export default CarePlanningSubTabHeader;
